<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-autocomplete
          id="bcko"
          ref="bcko"
          :clearable="!disableBcko"
          v-model="selectedBcko"
          :items="itemsBcko"
          :search-input.sync="searchBckoLocal"
          @focus="onBckoFocus"
          return-object
          :item-text="bckoItemText"
          item-value="id"
          label="KODE BC/KO"
          :loading="loadingBcko"
          :error-messages="bckoErrors"
          :readonly="disableBcko"
          :filled="disableBcko"
          :menu-props="disableBcko ? { value: false } : {}"
          hide-selected
          cache-items
          outlined
        >
          <template v-slot:no-data>
            <v-list-item>
              <v-list-item-content>
                <div v-if="loadingBcko" class="d-flex align-center py-1">
                  <v-progress-circular
                    indeterminate
                    size="18"
                    width="2"
                    color="primary"
                    class="mr-2"
                  />
                  <span>Sedang memuat data...</span>
                </div>
                <span v-else>Data tidak ditemukan</span>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-autocomplete>
        <FieldInfoHelper :show="showSubMerchantInfo" :type="infoType" :outlined="true" />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-autocomplete
          id="cmer"
          ref="cmer"
          :clearable="!disableCmer"
          v-model="selectedCmer"
          :items="itemsCmer"
          :search-input.sync="searchCmerLocal"
          @focus="onCmerFocus"
          return-object
          :item-text="cmerItemText"
          item-value="id"
          label="Merchant Category Segment"
          :loading="loadingCmer"
          :error-messages="cmerErrors"
          :readonly="disableCmer"
          :filled="disableCmer"
          :menu-props="disableCmer ? { value: false } : {}"
          hide-selected
          cache-items
          outlined
        >
          <template v-slot:no-data>
            <v-list-item>
              <v-list-item-content>
                <div v-if="loadingCmer" class="d-flex align-center py-1">
                  <v-progress-circular
                    indeterminate
                    size="18"
                    width="2"
                    color="primary"
                    class="mr-2"
                  />
                  <span>Sedang memuat data...</span>
                </div>
                <span v-else>Data tidak ditemukan</span>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-autocomplete>
        <FieldInfoHelper :show="showSubMerchantInfo" :type="infoType" :outlined="true" />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-text-field
          id="rmReferalCode"
          ref="rmReferalCode"
          outlined
          label="Referral Code"
          v-model="referralCodeLocal"
          :counter="16"
          maxlength="16"
          @change="touchReferral"
          @blur="touchReferral"
          :error-messages="referralCodeErrors"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import FieldInfoHelper from '@/components/inputer/FieldInfoHelper.vue';

export default {
  name: 'RegionalMappingFields',
  components: {
    FieldInfoHelper,
  },
  props: {
    bcko: {
      type: Object,
      default: null,
    },
    cmer: {
      type: Object,
      default: null,
    },
    referralCode: {
      type: String,
      default: '',
    },
    itemsBcko: {
      type: Array,
      default: () => [],
    },
    searchBcko: {
      type: String,
      default: '',
    },
    loadingBcko: {
      type: Boolean,
      default: false,
    },
    itemsCmer: {
      type: Array,
      default: () => [],
    },
    searchCmer: {
      type: String,
      default: '',
    },
    loadingCmer: {
      type: Boolean,
      default: false,
    },
    bckoErrors: {
      type: Array,
      default: () => [],
    },
    cmerErrors: {
      type: Array,
      default: () => [],
    },
    referralCodeErrors: {
      type: Array,
      default: () => [],
    },
    disableBcko: {
      type: Boolean,
      default: false,
    },
    disableCmer: {
      type: Boolean,
      default: false,
    },
    showSubMerchantInfo: {
      type: Boolean,
      default: false,
    },
    infoType: {
      type: String,
      default: '',
    },
  },
  computed: {
    selectedBcko: {
      get() {
        return this.bcko;
      },
      set(value) {
        this.$emit('update:bcko', value);
      },
    },
    selectedCmer: {
      get() {
        return this.cmer;
      },
      set(value) {
        this.$emit('update:cmer', value);
      },
    },
    searchBckoLocal: {
      get() {
        return this.searchBcko;
      },
      set(value) {
        this.$emit('update:searchBcko', value);
      },
    },
    searchCmerLocal: {
      get() {
        return this.searchCmer;
      },
      set(value) {
        this.$emit('update:searchCmer', value);
      },
    },
    referralCodeLocal: {
      get() {
        return this.referralCode;
      },
      set(value) {
        this.$emit('update:referralCode', value);
      },
    },
  },
  methods: {
    onBckoFocus() {
      if (this.disableBcko) {
        return;
      }
      this.$emit('focus-bcko');
    },
    onCmerFocus() {
      if (this.disableCmer) {
        return;
      }
      this.$emit('focus-cmer');
    },
    bckoItemText(item) {
      if (typeof item === 'object') {
        return `${item.branch_code_bcko || ''} - ${item.outlet_name || ''}`;
      }
      return item;
    },
    cmerItemText(item) {
      if (typeof item === 'object') {
        return `${item.code || ''} - ${item.definition || ''}`;
      }
      return item;
    },
    touchReferral() {
      this.$emit('touch-referral');
    },
  },
};
</script>
